import { RootState } from '../root.reducers';
import { ProcessOption } from './processOption.types';

// eslint-disable-next-line import/prefer-default-export
export const getProcessOptions = (state: RootState): ProcessOption[] => state.processOption.entities;

export const getProcessOptionsList = (state: RootState): ProcessOption[] =>
  state.processOption.entities;

export const getSelectedProcessOptions = (state: RootState): ProcessOption[] =>
  state.processOption.selected;

export const getProcessOptionsCreatedId = (state: RootState): string | null =>
  state.processOption.createdId;

export const isProcessOptionsCreatePopupOpen = (state: RootState): boolean =>
  state.processOption.ui.isCreatePopupOpen;

export const isProcessOptionsLoading = (state: RootState): boolean =>
  state.processOption.ui.isLoading;
